import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));
const AdminLoginPage = lazy(() => import('../pages/admin/login/page'));
const AdminProjectsPage = lazy(() => import('../pages/admin/projects/page'));
const AdminImagesPage = lazy(() => import('../pages/admin/images/page'));
const AdminNotificationsPage = lazy(() => import('../pages/admin/notifications/page'));
const AdminSettingsPage = lazy(() => import('../pages/admin/settings/page'));
const NotificationDetailPage = lazy(() => import('../pages/notification/detail/page'));
const ProjectDetailPage = lazy(() => import('../pages/project/detail/page'));
const ContactPage = lazy(() => import('../pages/contact/page'));
const CompanyPage = lazy(() => import('../pages/company/page'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/company',
    element: <CompanyPage />,
  },
  {
    path: '/contact',
    element: <ContactPage />,
  },
  {
    path: '/notification/:id',
    element: <NotificationDetailPage />,
  },
  {
    path: '/project/:id',
    element: <ProjectDetailPage />,
  },
  {
    path: '/admin/login',
    element: <AdminLoginPage />,
  },
  {
    path: '/admin/projects',
    element: <AdminProjectsPage />,
  },
  {
    path: '/admin/images',
    element: <AdminImagesPage />,
  },
  {
    path: '/admin/notifications',
    element: <AdminNotificationsPage />,
  },
  {
    path: '/admin/settings',
    element: <AdminSettingsPage />,
  },
  {
    path: '*',
    element: <NotFoundPage />,
  },
];

export default routes;
